export default "__VITE_PUBLIC_ASSET__f6395a13__"